var _g, _g2, _g3, _g4, _g5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "table-svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "left"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15,85C-4.3,65.7-4.3,34.3,15,15l35,35L15,85z"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 42.6,
    className: "st1",
    width: 22.7,
    height: 14.8
  }), /*#__PURE__*/React.createElement("text", {
    id: "left-label",
    transform: "matrix(1 0 0 1 4.6743 56.7932)",
    className: "st2 st3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "bottom"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85,85c-19.3,19.3-50.7,19.3-70,0l35-35L85,85z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.7,
    y: 81.5,
    className: "st1",
    width: 22.7,
    height: 17
  }), /*#__PURE__*/React.createElement("text", {
    id: "bottom-label",
    transform: "matrix(1 0 0 1 43.34 95.7451)",
    className: "st2 st3"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "right"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85,15c19.3,19.3,19.3,50.7,0,70L50,50L85,15z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.3,
    y: 42.6,
    className: "st1",
    width: 22.7,
    height: 14.8
  }), /*#__PURE__*/React.createElement("text", {
    id: "right-label",
    transform: "matrix(1 0 0 1 82.0057 56.7932)",
    className: "st2 st3"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "top"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15,15C34.3-4.3,65.7-4.3,85,15L50,50L15,15z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.7,
    y: 4,
    className: "st1",
    width: 22.7,
    height: 17
  }), /*#__PURE__*/React.createElement("text", {
    id: "top-label",
    transform: "matrix(1 0 0 1 43.34 18.2004)",
    className: "st2 st3"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "center"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 50,
    cy: 50,
    r: 28
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 22,
    className: "st1",
    width: 56,
    height: 56
  }), /*#__PURE__*/React.createElement("text", {
    id: "center-label",
    transform: "matrix(1 0 0 1 49 62)",
    className: "st2 st4"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.3cee794ededa5c5f18413b9c65ac285c.svg";
export { ForwardRef as ReactComponent };